import { Routes } from '@angular/router';

import { AuthGuard } from '@plugins/client/auth';
import { queueCanActivate } from '@plugins/client/routing/queue-can-activate.guard';
import { TranslationGuard } from '@plugins/client/translation';

import { AppGuard, InstanceGuard } from './guards';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'admin',
        canActivate: [queueCanActivate([AuthGuard, InstanceGuard]), AppGuard],
        canActivateChild: [TranslationGuard],
        data: { role: 'editor' },
        loadChildren: () => import('./backoffice/backoffice.routes'),
      },
      {
        path: '',
        canActivate: [queueCanActivate([AuthGuard, InstanceGuard]), AppGuard],
        canActivateChild: [TranslationGuard],
        loadChildren: () => import('./frontend/frontend.routes'),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
